import axios from "axios";
import { HERE_API_KEY, IP_GEO_API_KEY } from "../constants";

export const getUserLocation = () => {
  const response = axios({
    method: "get",
    url: `https://api.ipgeolocation.io/ipgeo?apiKey=${IP_GEO_API_KEY}`,
  });

  return response;
};

export const getUserCurrentLocation = (_coords) => {
  console.log("coords", _coords);
  const response = axios({
    method: "get",
    url: `https://geocode.search.hereapi.com/v1/revgeocode?at=${_coords}&apiKey=${HERE_API_KEY}`,
  });

  return response;
};
